import { format, parseISO } from 'date-fns'
export const SearchColumns = [
  {
    field: 'created_datetime',
    headerName: 'Created On',
    width: 181,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 167,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 230,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'state',
    headerName: 'Location',
    width: 100,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'procedure_code',
    headerName: 'Case Type',
    headerClassName: 'super-app-theme--header',
    width: 170,
  },
]

export const ReadyForPickupColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    width: 120,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },

  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 120,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 190,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 110,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'first_name',
    headerName: 'Receive From',
    width: 170,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.last_name || ''}, ${params.row.first_name || ''}`,
  },
  {
    field: 'state',
    headerName: 'Location',
    width: 100,
    headerClassName: 'super-app-theme--header',
  },
]

export const DispatchColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    width: 130,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },

  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 120,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 190,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'first_name',
    headerName: 'Deliver To',
    headerClassName: 'super-app-theme--header',
    width: 190,
    valueGetter: (params) =>
      `${params.row.first_name || ''}` + (params.row.last_name ? `, ${params.row.last_name || ''}` : ''),
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 100,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'state',
    headerName: 'Location',
    headerClassName: 'super-app-theme--header',
    width: 100,
  },
]

export const InProgressColumns = [
  {
    field: 'created_datetime',
    headerName: 'Assigned On',
    width: 120,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.created_datetime + ''), 'yyyy-MM-dd')}`,
  },
  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 120,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 120,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'first_name',
    headerName: 'Assigned To',
    headerClassName: 'super-app-theme--header',
    width: 150,
    valueGetter: (params) => `${params.row.last_name || ''}, ${params.row.first_name || ''}`,
  },
  {
    field: 'state',
    headerName: 'Location',
    headerClassName: 'super-app-theme--header',
    width: 100,
  },
]

export const CompleteColumns = [
  {
    field: 'updated_datetime',
    headerName: 'Time Of Release',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (param) => `${format(parseISO(param.row.updated_datetime + ''), 'yyyy-MM-dd HH:mm:ss')}`,
  },

  {
    field: 'case_number',
    headerName: 'TRF ID',
    width: 120,
    headerClassName: 'super-app-theme--header',
  },
  {
    field: 'patient_first_name',
    headerName: 'Patient Name',
    width: 200,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.patient_last_name || ''}, ${params.row.patient_first_name || ''}`,
  },
  {
    field: 'stat_flag',
    headerName: 'Priority',
    width: 100,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => {
      if (params.row.stat_flag) {
        return 'HIGH'
      } else return 'Standard'
    },
  },
  {
    field: 'first_name',
    headerName: 'Signature',
    width: 160,
    headerClassName: 'super-app-theme--header',
    valueGetter: (params) => `${params.row.first_name || ''}, ${params.row.last_name || ''}`,
  },
  // {
  //   field: 'outcome',
  //   headerName: 'Result',
  //   width: 145,
  //   headerClassName: 'super-app-theme--header',
  // },
]
